import { render } from "./Trimming.vue?vue&type=template&id=4655f093&scoped=true"
import script from "./Trimming.vue?vue&type=script&lang=js"
export * from "./Trimming.vue?vue&type=script&lang=js"

import "./Trimming.vue?vue&type=style&index=0&id=4655f093&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4655f093"]])

export default __exports__